import gql from 'graphql-tag'

export const GET_NOTIFICATION_BANNER_RESULT = gql`
  query GetNotificationBannerResult {
    notificationbanner {
      notificationButtonText
      notificationButtonUrl
      notificationContentList
      notificationDescription
      notificationDisplayEverywhere
      notificationDisplayUrls
      notificationPrimaryButton
      notificationPublished
      notificationTitle
      notificationType
      notificationUnpublished
    }
  }
`
